import React, { useRef } from 'react';
import { Box, Button, Paper, Tooltip, useTheme } from '@mui/material';
import { observer } from 'mobx-react';
import useData from './hooks';
import { ButtonBoxStyle, ToolBarStyle } from './styles';
import { HistoricalDataName, HistoricalDataToolBarName } from './const';
import CustomList from '10.quickConnect.app/components/domain/Home/Shared/CustomList';
import DeclarationLine from '10.quickConnect.app/components/domain/Home/Declarations/DeclarationLine';
import { ListColumnForCustomListContainer } from '10.quickConnect.app/components/domain/Home/styles';

const HistoricalData = () => {
  const { t, declarations, sortFn, isMobile, navigateToOldDeclaration } = useData();
  const theme = useTheme();
  const scrollTarget = useRef<HTMLElement>();

  return (
    <>
      <Paper elevation={0} data-cy={HistoricalDataToolBarName} sx={ToolBarStyle(isMobile)}>
        <Box sx={ButtonBoxStyle(isMobile)}>
          <Tooltip title={t('qcapp_histo_edited_search_old').toString()}>
            <Button variant="contained" onClick={navigateToOldDeclaration}>
              {t('qcapp_histo_edited_search_old')}
            </Button>
          </Tooltip>
        </Box>
      </Paper>
      <Box data-cy={HistoricalDataName} sx={ListColumnForCustomListContainer(theme)} ref={scrollTarget}>
        <CustomList items={declarations} RenderLine={DeclarationLine} sortFn={sortFn} />
      </Box>
    </>
  );
};
export default observer(HistoricalData);
